module.exports = __webpack_public_path__ + "static/media/testimonials.f7c91068.jpg";